// extracted by mini-css-extract-plugin
module.exports = {"title":"LineChartStyle__title--1wBzN"};